import { Link } from 'react-router-dom';
import { img, readdy } from '@/utils/images';
import { getSiteConfig } from '@/utils/siteConfigStore';
import ScrollReveal from '@/components/base/ScrollReveal';

export default function BrandStrength() {
  const { brandStats } = getSiteConfig();
  return (
    <section className="relative bg-brand-gray py-16 md:py-24 overflow-hidden">
      <div className="absolute inset-0 opacity-[0.06]">
        <img
          src={readdy('brand-str-bg-v2')}
          alt=""
          className="w-full h-full object-cover"
        />
      </div>
      <div className="px-6 md:px-10">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-center">
            <ScrollReveal variant="fade-right">
              <p className="text-brand-brown text-sm tracking-widest mb-3 font-medium">品牌积淀</p>
              <h2 className="text-3xl md:text-4xl font-bold text-brand-deep mb-6 leading-tight">
                十余年专注，
                <br />
                只为更专业的健康管理
              </h2>
              <p className="text-gray-600 text-sm md:text-base leading-relaxed mb-6">
                麦杰集团深耕健康体重管理领域十余年，从一家门店起步，逐步建立起
                覆盖多省市场的品牌连锁体系。我们始终坚持"绿色、高效、无忧"的
                服务理念，融合中医经络理论与现代健康管理科学，为每一位顾客提供
                个性化、可持续的健康纤体方案。
              </p>
              <p className="text-gray-600 text-sm md:text-base leading-relaxed mb-8">
                十余年来，我们建立了完整的产品研发、品牌推广、营销策划、培训赋能、
                售后服务五大能力体系，确保每一家门店都能为顾客提供标准化、高品质的
                健康管理服务。
              </p>
              <Link
                to="/about"
                className="inline-flex items-center gap-2 px-6 py-3 bg-brand-light text-brand-dark text-sm font-medium rounded-full hover:bg-brand-cream transition-colors cursor-pointer"
              >
                了解更多
                <i className="ri-arrow-right-line" />
              </Link>

              <div className="flex gap-12 mt-10">
                {brandStats.slice(0, 2).map((stat) => (
                  <div key={stat.label}>
                    <p className="text-4xl md:text-5xl font-bold text-brand-deep">{stat.value}</p>
                    <p className="text-xs text-gray-400 mt-1">{stat.label}</p>
                  </div>
                ))}
              </div>
            </ScrollReveal>

            <ScrollReveal variant="fade-left" delay={150}>
              <div className="relative">
                <div className="rounded-2xl overflow-hidden aspect-[4/5]">
                  <img
                    src={img('readdy/b6d1aa0f3bb14a30f9100c17454f83e0.png')}
                    alt="品牌团队"
                    className="w-full h-full object-cover object-top"
                  />
                </div>
                <div className="absolute top-4 left-4 bg-white/85 backdrop-blur-sm text-brand-deep text-xs font-medium px-4 py-2 rounded-full">
                  品牌直营
                </div>
                <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/50 to-transparent rounded-b-2xl p-6">
                  <p className="text-white text-sm font-medium">专业顾问团队</p>
                  <p className="text-white/70 text-xs mt-1">标准化培训 · 系统化服务</p>
                </div>
              </div>
            </ScrollReveal>
          </div>
        </div>
      </div>
    </section>
  );
}